import axios from 'axios';
import { getApiEnvironment } from '@innovyze/stylovyze/lib/utils/getApiEnvironment';
import { getService } from '@innovyze/stylovyze/lib/utils/getService';
import { getBearerAuth0Token } from '@innovyze/stylovyze/lib/utils/authUtils';
import config from './config.api';
// Service configuration docs: https://dev.azure.com/innovyze/global/_wiki/wikis/global.wiki/830/2020-10-13-Centralized-Services
const options = {
    baseURL: getService('idp', config, getApiEnvironment()),
    timeout: 6000,
};
const idp = axios.create(options);
idp.interceptors.request.use(conf => {
    conf.headers.Authorization = getBearerAuth0Token();
    return conf;
}, error => {
    Promise.reject(error);
});
export default idp;
